import { apiPost } from "../shared/apiClient";
import { createCachedFetcher } from "../shared/cachedFetcher";

const fetchSupplierGroupsRaw = createCachedFetcher(
  () => apiPost("/whatsapp/get_supplier_tags", {}).then(res =>
    res.data?.success ? (res.data.data || []).map(g => ({ value: g.id, label: g.name })) : []
  ),
  { fallback: [] }
);

export function fetchSupplierGroups({ force = false } = {}) {
  return fetchSupplierGroupsRaw(undefined, { force });
}

const fetchSuppliersV2Raw = createCachedFetcher(
  () => apiPost("/whatsapp/get_suppliersV2", {}).then(res =>
    res.data?.success ? (res.data.data || []) : []
  ),
  { fallback: [] }
);

export function fetchSuppliersV2({ force = false } = {}) {
  return fetchSuppliersV2Raw(undefined, { force });
}
